<template>
  <FriedModal
    v-if="visible"
    :size="ModalSize.Small"
    class="review-changes-modal"
    :closable="false"
    :loading="loading"
  >
    <template #header>
      <FriedModalHeader :header="`${sender} ${title}`" />
    </template>
    <div class="review-changes-container">
      <FriedModalSubContainer :padded="false">
        <div class="description">
          {{ documentName }} {{ t('has-been-updated-click-to-review') }}
        </div>
        <div class="message-container">
          <div class="date">
            <span class="day">{{ day }}</span>
            <span>{{ time }}</span>
          </div>
          <div>{{ message }}</div>
        </div>
      </FriedModalSubContainer>
    </div>
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton
          data-external="signing-page-review-changes-modal"
          class="review-changes-button"
          @click="$emit('review')"
          >{{ t('review-new-version') }}</FriedButton
        >
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>
<script lang="ts">
import { DateTime } from 'luxon';
import { ModalSize } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import type { PropType } from 'vue';
import { defineComponent, computed } from 'vue';
import type { DocumentRecipientRevision } from '../types/document-revision';

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
    },
    documentName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    sender: {
      type: String,
      default: '',
    },
    latestRevision: {
      type: Object as PropType<DocumentRecipientRevision>,
      default: null,
    },
    loading: {
      type: Boolean,
    },
  },
  emits: ['review'],
  setup(props) {
    const { t } = useI18n();
    const day = computed(() =>
      DateTime.fromMillis(props.latestRevision?.createdAt).toRelativeCalendar({
        unit: 'days',
      })
    );

    const time = computed(() =>
      DateTime.fromMillis(props.latestRevision?.createdAt).toLocaleString(DateTime.TIME_SIMPLE)
    );

    const message = computed(() => props.latestRevision?.message);

    return {
      ModalSize,
      t,
      day,
      time,
      message,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '../alert-variables';

.review-changes-modal {
  .review-changes-container {
    .description {
      margin-bottom: var(--spacing-150);
    }

    .message-container {
      border-radius: var(--radius-medium);
      background: var(--info-light);
      padding: calc(var(--spacing-150) * 0.5) var(--spacing-100);
      color: var(--info-dark);

      .date {
        .day {
          margin-right: var(--spacing-25);
          font-weight: 600;
          text-transform: capitalize;
        }
      }
    }
  }

  .review-changes-button {
    width: 100%;
  }
}
</style>
